import type { ReactNode } from 'react';

export const symbol_horizontal_align_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M788.5-168.5Q780-177 780-190v-580q0-13 8.5-21.5T810-800q13 0 21.5 8.5T840-770v580q0 13-8.5 21.5T810-160q-13 0-21.5-8.5ZM604-450H150q-13 0-21.5-8.5T120-480q0-13 8.5-21.5T150-510h454l-96-96q-9-9-8.5-21t9.5-21q9-9 21.5-9t21.5 9l147 147q5 5 7 10t2 11q0 6-2 11t-7 10L547-307q-9 9-21.5 8.5T504-308q-9-9-9-21.5t9-21.5l100-99Z"
		/>
	</svg>
);
